import "@hotwired/turbo-rails"
Turbo.session.drive = false

import { turboConfirmMethod } from "./design_system/turbo_confirm"
Turbo.config.forms.confirm = turboConfirmMethod

import TurboPower from 'turbo_power'
TurboPower.initialize(Turbo.StreamActions)

import "./stimulus/bo";
